export { AssetProperties } from './AssetProperties';
export type { AssetPropertiesProps } from './AssetProperties';
